import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormLabel,
  RadioGroup,
  RadioGroupProps,
  accordionSummaryClasses,
} from '@mui/material';

import { COLOR_BORDER, COLOR_DARK } from '~/components/App/theme';
import { DropdownIcon } from '~/components/icons';
import { IConfigurationOption } from '~/domain/IConfigurationOption';

import { ConfigurationPack } from './ConfigurationPack';

interface IConfigurationRadio {
  label: React.ReactNode;
  packs: IConfigurationOption[];
  onChange: RadioGroupProps['onChange'];
  value?: string;
}

export const ConfigurationPackSet = React.memo<IConfigurationRadio>(
  function ConfigurationRadio(props) {
    const { label, packs, onChange, value } = props;

    return (
      <FormControl
        sx={{
          width: '100%',
          borderBottom: `1px solid ${COLOR_BORDER}`,
          '&:last-of-type': { borderBottom: 0 },
        }}
      >
        <Accordion square disableGutters>
          <AccordionSummary
            expandIcon={
              <DropdownIcon sx={{ fontSize: 16, height: 7, width: 12 }} />
            }
            sx={{
              [`> div.${accordionSummaryClasses.expanded}`]: { my: 1.5 },
              '&:first-of-type': { borderTop: 0 },
              height: 48,
            }}
          >
            <FormLabel sx={{ color: COLOR_DARK }}>{label}</FormLabel>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
            <RadioGroup value={value} onChange={onChange}>
              {packs.map((pack) => {
                return (
                  <ConfigurationPack pack={pack} key={pack.code} />
                );
              })}
            </RadioGroup>
          </AccordionDetails>
        </Accordion>
      </FormControl>
    );
  }
);
